import { createFileRoute } from '@tanstack/react-router'
import { Library } from '@/features/library/Library'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/library')({
  component: LibraryPage,
})

function LibraryPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Library" meta="Everything else" />
      <div className="mt-6">
        <Library />
      </div>
    </div>
  )
}
